import { NamedColor } from "src/types/game.types"

const NamedColors0: NamedColor[] = [
    {
        "name": "Aqua Deep",
        "hex": "#014B43",
        "difficulty": 0
    },
    {
        "name": "Evening Sea",
        "hex": "#024E46",
        "difficulty": 0
    },
    {
        "name": "Zuccini",
        "hex": "#044022",
        "difficulty": 0
    },
    {
        "name": "Holly",
        "hex": "#011D13",
        "difficulty": 0
    },
    {
        "name": "Crimson",
        "hex": "#DC143C",
        "difficulty": 0
    },
    {
        "name": "Auburn",
        "hex": "#A52A2A",
        "difficulty": 0
    },
    {
        "name": "Teal",
        "hex": "#008080",
        "difficulty": 0
    },
    {
        "name": "Marigold",
        "hex": "#EAA221",
        "difficulty": 0
    },
    {
        "name": "Jade",
        "hex": "#00A86B",
        "difficulty": 0
    },
    {
        "name": "Lilac",
        "hex": "#C8A2C8",
        "difficulty": 0
    },
    {
        "name": "Ruby",
        "hex": "#E0115F",
        "difficulty": 0
    },
    {
        "name": "Cyan",
        "hex": "#00FFFF",
        "difficulty": 0
    },
    {
        "name": "Caramel",
        "hex": "#FFD700",
        "difficulty": 0
    },
    {
        "name": "Lavender",
        "hex": "#967bb6",
        "difficulty": 0
    },
    {
        "name": "Tangerine",
        "hex": "#FFA500",
        "difficulty": 0
    },
    {
        "name": "Plum",
        "hex": "#8e4585",
        "difficulty": 0
    },
    {
        "name": "Sapphire",
        "hex": "#0F52BA",
        "difficulty": 0
    },
    {
        "name": "Moss",
        "hex": "#8A9A5B",
        "difficulty": 0
    },
    {
        "name": "Ebony",
        "hex": "#282C34",
        "difficulty": 0
    },
    {
        "name": "Ivory",
        "hex": "#FFFFF0",
        "difficulty": 0
    },
    {
        "name": "Mint",
        "hex": "#3EB489",
        "difficulty": 0
    },
    {
        "name": "Cinnamon",
        "hex": "#D2691E",
        "difficulty": 0
    },
    {
        "name": "Olive",
        "hex": "#808000",
        "difficulty": 0
    },
    {
        "name": "Sandalwood",
        "hex": "#DECBBD",
        "difficulty": 0
    },
    {
        "name": "Maroon",
        "hex": "#800000",
        "difficulty": 0
    },
    {
        "name": "Cactus",
        "hex": "#5B6F55",
        "difficulty": 0
    },
    {
        "name": "Mocha",
        "hex": "#6F372D",
        "difficulty": 0
    },
    {
        "name": "Pine",
        "hex": "#0a481e",
        "difficulty": 0
    },
    {
        "name": "Bumblebee",
        "hex": "#FFD700",
        "difficulty": 0
    },
    {
        "name": "Flamingo",
        "hex": "#FC8EAC",
        "difficulty": 0
    },
    {
        "name": "Toffee",
        "hex": "#A5673F",
        "difficulty": 0
    },
    {
        "name": "Ash",
        "hex": "#B2BEB5",
        "difficulty": 0
    },
    {
        "name": "Goldenrod",
        "hex": "#DAA520",
        "difficulty": 0
    },
    {
        "name": "Violet",
        "hex": "#7F00FF",
        "difficulty": 0
    },
    {
        "name": "Amber",
        "hex": "#FFBF00",
        "difficulty": 0
    },
    {
        "name": "Charcoal",
        "hex": "#36454F",
        "difficulty": 0
    },
    {
        "name": "Fern",
        "hex": "#71BC78",
        "difficulty": 0
    },
    {
        "name": "Sunflower",
        "hex": "#FFC512",
        "difficulty": 0
    },
    {
        "name": "Lapis",
        "hex": "#07249e",
        "difficulty": 0
    },
    {
        "name": "Peach",
        "hex": "#f98a87",
        "difficulty": 0
    },
    {
        "name": "Steel",
        "hex": "#738595",
        "difficulty": 0
    },
    {
        "name": "Brick",
        "hex": "#aa4a44",
        "difficulty": 0
    },
    {
        "name": "Platinum",
        "hex": "#E5E4E2",
        "difficulty": 0
    },
    {
        "name": "Pumpkin",
        "hex": "#FF7518",
        "difficulty": 0
    },
    {
        "name": "Azure",
        "hex": "#007FFF",
        "difficulty": 0
    },
    {
        "name": "Merlot",
        "hex": "#730039",
        "difficulty": 0
    },
    {
        "name": "Pewter",
        "hex": "#8C8E8C",
        "difficulty": 0
    },
    {
        "name": "Canary",
        "hex": "#FFFF99",
        "difficulty": 0
    },
    {
        "name": "Brass",
        "hex": "#B5A642",
        "difficulty": 0
    },
    {
        "name": "Chestnut",
        "hex": "#954535",
        "difficulty": 0
    },
    {
        "name": "Pearl",
        "hex": "#F2EDE4",
        "difficulty": 0
    },
    {
        "name": "Lemon",
        "hex": "#FFF700",
        "difficulty": 0
    },
    {
        "name": "Copper",
        "hex": "#B87333",
        "difficulty": 0
    },
    {
        "name": "Rose",
        "hex": "#930050",
        "difficulty": 0
    },
    {
        "name": "Grape",
        "hex": "#6F2DA8",
        "difficulty": 0
    },
    {
        "name": "Honey",
        "hex": "#D4AF37",
        "difficulty": 0
    },
    {
        "name": "Cocoa",
        "hex": "#D2691E",
        "difficulty": 0
    },
    {
        "name": "Lime",
        "hex": "#00FF00",
        "difficulty": 0
    },
    {
        "name": "Silver",
        "hex": "#C0C0C0",
        "difficulty": 0
    },
    {
        "name": "Golden",
        "hex": "#FFD700",
        "difficulty": 0
    },
    {
        "name": "Marble",
        "hex": "#EFEBE9",
        "difficulty": 0
    },
    {
        "name": "Cherry",
        "hex": "#DC143C",
        "difficulty": 0
    },
    {
        "name": "Cotton",
        "hex": "#FAF9F6",
        "difficulty": 0
    },
    {
        "name": "Shadow",
        "hex": "#757575",
        "difficulty": 0
    },
    {
        "name": "Mango",
        "hex": "#FF8243",
        "difficulty": 0
    },
    {
        "name": "Wine",
        "hex": "#722F37",
        "difficulty": 0
    },
    {
        "name": "Daffodil",
        "hex": "#FFFF31",
        "difficulty": 0
    },
    {
        "name": "Scarlet",
        "hex": "#FF2400",
        "difficulty": 0
    },
    {
        "name": "Pear",
        "hex": "#D1E231",
        "difficulty": 0
    },
    {
        "name": "Aqua",
        "hex": "#00FFFF",
        "difficulty": 0
    },
    {
        "name": "Aquamarine",
        "hex": "#7FFFD4",
        "difficulty": 0
    },
    {
        "name": "Blackberry",
        "hex": "#4D2A4D",
        "difficulty": 0
    },
    {
        "name": "Blueberry",
        "hex": "#464A88",
        "difficulty": 0
    },
    {
        "name": "Strawberry",
        "hex": "#FF3877",
        "difficulty": 0
    },
    {
        "name": "Sky",
        "hex": "#5ec4d6",
        "difficulty": 0
    },
    {
        "name": "Vanilla",
        "hex": "#F3E5AB",
        "difficulty": 0
    },
    {
        "name": "Lemonade",
        "hex": "#FFFACD",
        "difficulty": 0
    },
    {
        "name": "Wheat",
        "hex": "#F5DEB3",
        "difficulty": 0
    },
    {
        "name": "Navy",
        "hex": "#000080",
        "difficulty": 0
    },
    {
        "name": "Avocado",
        "hex": "#568203",
        "difficulty": 0
    },
    {
        "name": "Beige",
        "hex": "#F5F5DC",
        "difficulty": 0
    },
    {
        "name": "Bone",
        "hex": "#E3DAC9",
        "difficulty": 0
    },
    {
        "name": "bronze",
        "hex": "#CD7F32",
        "difficulty": 0
    },
    {
        "name": "Frost",
        "hex": "#E1E4FF",
        "difficulty": 0
    },
    {
        "name": "Mustard",
        "hex": "#FFDB58",
        "difficulty": 0
    },
    {
        "name": "Oatmeal",
        "hex": "#E6D8AD",
        "difficulty": 0
    }
]

const NamedColors1: NamedColor[] = [
    {
        "name": "Amethyst",
        "hex": "#9966CC",
        "difficulty": 1
    },
    {
        "name": "Emerald",
        "hex": "#50C878",
        "difficulty": 1
    },
    {
        "name": "Magenta",
        "hex": "#FF00FF",
        "difficulty": 1
    },
    {
        "name": "Coral",
        "hex": "#FF7F50",
        "difficulty": 1
    },
    {
        "name": "Citrine",
        "hex": "#E4D00A",
        "difficulty": 1
    },
    {
        "name": "Topaz",
        "hex": "#FFC87C",
        "difficulty": 1
    },
    {
        "name": "Turquoise",
        "hex": "#40E0D0",
        "difficulty": 1
    },
    {
        "name": "Peridot",
        "hex": "#E6E200",
        "difficulty": 1
    },
    {
        "name": "Mauve",
        "hex": "#E0B0FF",
        "difficulty": 1
    },
    {
        "name": "Citrus",
        "hex": "#FFA500",
        "difficulty": 1
    },
    {
        "name": "Citron",
        "hex": "#9FA91F",
        "difficulty": 1
    },
    {
        "name": "Slate",
        "hex": "#708090",
        "difficulty": 1
    },
    {
        "name": "Apricot",
        "hex": "#FBCEB1",
        "difficulty": 1
    },
    {
        "name": "Fuchsia",
        "hex": "#FF00FF",
        "difficulty": 1
    },
    {
        "name": "Pomegranate",
        "hex": "#F44336",
        "difficulty": 1
    },
    {
        "name": "Mulberry",
        "hex": "#C54B8C",
        "difficulty": 1
    },
    {
        "name": "Garnet",
        "hex": "#733635",
        "difficulty": 1
    },
    {
        "name": "Petal",
        "hex": "#F3E5AB",
        "difficulty": 1
    },
    {
        "name": "Juniper",
        "hex": "#74918E",
        "difficulty": 1
    },
    {
        "name": "Honeydew",
        "hex": "#F0FFF0",
        "difficulty": 1
    },
    {
        "name": "Buttercup",
        "hex": "#F3AD16",
        "difficulty": 1
    },
    {
        "name": "Cobalt",
        "hex": "#0047AB",
        "difficulty": 1
    },
    {
        "name": "Hazelnut",
        "hex": "#996633",
        "difficulty": 1
    },
    {
        "name": "Pistachio",
        "hex": "#93C572",
        "difficulty": 1
    },
    {
        "name": "Hibiscus",
        "hex": "#ED1C24",
        "difficulty": 1
    },
    {
        "name": "Sandstone",
        "hex": "#796D62",
        "difficulty": 1
    },
    {
        "name": "Cardinal",
        "hex": "#C41E3A",
        "difficulty": 1
    },
    {
        "name": "Sherbet",
        "hex": "#FFD8B1",
        "difficulty": 1
    },
    {
        "name": "Nutmeg",
        "hex": "#8C5D2C",
        "difficulty": 1
    },
    {
        "name": "Peppermint",
        "hex": "#C1F0D9",
        "difficulty": 1
    },
    {
        "name": "Velvet",
        "hex": "#750851",
        "difficulty": 1
    },
    {
        "name": "Lagoon",
        "hex": "#006994",
        "difficulty": 1
    },
    {
        "name": "Rosewood",
        "hex": "#65000B",
        "difficulty": 1
    },
    {
        "name": "Sage",
        "hex": "#BCB88A",
        "difficulty": 1
    },
    {
        "name": "Carnation",
        "hex": "#FFA6C9",
        "difficulty": 1
    },
    {
        "name": "Linen",
        "hex": "#FAF0E6",
        "difficulty": 1
    },
    {
        "name": "Tulip",
        "hex": "#FF878D",
        "difficulty": 1
    },
    {
        "name": "Hazel",
        "hex": "#8E7618",
        "difficulty": 1
    },
    {
        "name": "Champagne",
        "hex": "#F7E7CE",
        "difficulty": 1
    },
    {
        "name": "Oyster",
        "hex": "#D4D4D4",
        "difficulty": 1
    },
    {
        "name": "Eggplant",
        "hex": "#614051",
        "difficulty": 1
    },
    {
        "name": "Dusk",
        "hex": "#897f98",
        "difficulty": 1
    },
    {
        "name": "Raspberry",
        "hex": "#E30B5C",
        "difficulty": 1
    },
    {
        "name": "Sunset",
        "hex": "#FAD6A5",
        "difficulty": 1
    },
    {
        "name": "Moonlight",
        "hex": "#ACACAC",
        "difficulty": 1
    },
    {
        "name": "Blossom",
        "hex": "#F2BAC9",
        "difficulty": 1
    },
    {
        "name": "Obsidian",
        "hex": "#000000",
        "difficulty": 1
    },
    {
        "name": "Meadow",
        "hex": "#388E3C",
        "difficulty": 1
    },
    {
        "name": "Abyss",
        "hex": "#000C15",
        "difficulty": 1
    },
    {
        "name": "Sunrise",
        "hex": "#FFCC33",
        "difficulty": 1
    },
    {
        "name": "Mist",
        "hex": "#D7E4F2",
        "difficulty": 1
    },
    {
        "name": "Evergreen",
        "hex": "#014F0D",
        "difficulty": 1
    },
    {
        "name": "Midnight",
        "hex": "#191970",
        "difficulty": 1
    },
    {
        "name": "Butterfly",
        "hex": "#7A5DC7",
        "difficulty": 1
    },
    {
        "name": "Maple",
        "hex": "#D2691E",
        "difficulty": 1
    },
    {
        "name": "Silk",
        "hex": "#F9E4C6",
        "difficulty": 1
    },
    {
        "name": "Bamboo",
        "hex": "#DAEAD8",
        "difficulty": 1
    },
    {
        "name": "Twilight",
        "hex": "#4C3449",
        "difficulty": 1
    },
    {
        "name": "Butterscotch",
        "hex": "#E69E5C",
        "difficulty": 1
    },
    {
        "name": "Graphite",
        "hex": "#383838",
        "difficulty": 1
    },
    {
        "name": "Cedar",
        "hex": "#BDB76B",
        "difficulty": 1
    },
    {
        "name": "Basil",
        "hex": "#3D8B37",
        "difficulty": 1
    },
    {
        "name": "Onyx",
        "hex": "#464646",
        "difficulty": 1
    },
    {
        "name": "Honeysuckle",
        "hex": "#FFAB87",
        "difficulty": 1
    },
    {
        "name": "Ivy",
        "hex": "#2E8B57",
        "difficulty": 1
    },
    {
        "name": "Clementine",
        "hex": "#F96D00",
        "difficulty": 1
    },
    {
        "name": "Grapefruit",
        "hex": "#FF6347",
        "difficulty": 1
    },
    {
        "name": "Kiwi",
        "hex": "#8EE53F",
        "difficulty": 1
    },
    {
        "name": "Watermelon",
        "hex": "#FC6C85",
        "difficulty": 1
    },
    {
        "name": "Granite",
        "hex": "#676767",
        "difficulty": 1
    },
    {
        "name": "Walnut",
        "hex": "#773F1A",
        "difficulty": 1
    },
    {
        "name": "Mahogany",
        "hex": "#C04000",
        "difficulty": 1
    },
    {
        "name": "Oak",
        "hex": "#C0B283",
        "difficulty": 1
    },
    {
        "name": "Mushroom",
        "hex": "#BA8759",
        "difficulty": 1
    },
    {
        "name": "Rust",
        "hex": "#B7410E",
        "difficulty": 1
    },
    {
        "name": "Cantaloupe",
        "hex": "#FFA500",
        "difficulty": 1
    },
    {
        "name": "Jasmine",
        "hex": "#F8DE7E",
        "difficulty": 1
    },
    {
        "name": "Kale",
        "hex": "#5A7247",
        "difficulty": 1
    },
    {
        "name": "Pecan",
        "hex": "#B87D5B",
        "difficulty": 1
    },
    {
        "name": "Sepia",
        "hex": "#704214",
        "difficulty": 1
    },
    {
        "name": "Spruce",
        "hex": "#3B5B34",
        "difficulty": 1
    },
    {
        "name": "Swamp",
        "hex": "#001B1C",
        "difficulty": 1
    },
    {
        "name": "Tropical Rain Forest",
        "hex": "#00755E",
        "difficulty": 1
    },
]

const NamedColors2: NamedColor[] = [
    {
        "name": "Saffron",
        "hex": "#F4C430",
        "difficulty": 2
    },
    {
        "name": "Indigo",
        "hex": "#4B0082",
        "difficulty": 2
    },
    {
        "name": "Vermilion",
        "hex": "#E34234",
        "difficulty": 2
    },
    {
        "name": "Orchid",
        "hex": "#DA70D6",
        "difficulty": 2
    },
    {
        "name": "Blush",
        "hex": "#DE5D83",
        "difficulty": 2
    },
    {
        "name": "Sienna",
        "hex": "#A0522D",
        "difficulty": 2
    },
    {
        "name": "Peacock",
        "hex": "#33A1C9",
        "difficulty": 2
    },
    {
        "name": "Papaya",
        "hex": "#FFEFD5",
        "difficulty": 2
    },
    {
        "name": "Amaranth",
        "hex": "#E52B50",
        "difficulty": 2
    },
    {
        "name": "Currant",
        "hex": "#AA4B6B",
        "difficulty": 2
    },
    {
        "name": "Turmeric",
        "hex": "#EAC117",
        "difficulty": 2
    },
    {
        "name": "Poppy",
        "hex": "#E63946",
        "difficulty": 2
    },
    {
        "name": "Persimmon",
        "hex": "#FF6347",
        "difficulty": 2
    },
    {
        "name": "Marmalade",
        "hex": "#FFA500",
        "difficulty": 2
    },
    {
        "name": "Beryl",
        "hex": "#E6FFFE",
        "difficulty": 2
    },
    {
        "name": "Thistle",
        "hex": "#D8BFD8",
        "difficulty": 2
    },
    {
        "name": "Ochre",
        "hex": "#CC7722",
        "difficulty": 2
    },
    {
        "name": "Citronella",
        "hex": "#C5E17A",
        "difficulty": 2
    },
    {
        "name": "Eucalyptus",
        "hex": "#44D7A8",
        "difficulty": 2
    },
    {
        "name": "Paprika",
        "hex": "#8C3813",
        "difficulty": 2
    },
    {
        "name": "Peony",
        "hex": "#B768A2",
        "difficulty": 2
    },
    {
        "name": "Tawny",
        "hex": "#CD5700",
        "difficulty": 2
    },
    {
        "name": "Chartreuse",
        "hex": "#dfff00",
        "difficulty": 2
    },
    {
        "name": "Cypress",
        "hex": "#5C7E61",
        "difficulty": 2
    },
    {
        "name": "Bisque",
        "hex": "#FFE4C4",
        "difficulty": 2
    },
    {
        "name": "Wisteria",
        "hex": "#C9A0DC",
        "difficulty": 2
    },
    {
        "name": "Cerulean",
        "hex": "#007BA7",
        "difficulty": 2
    },
    {
        "name": "Pansy",
        "hex": "#78184A",
        "difficulty": 2
    },
    {
        "name": "Russet",
        "hex": "#80461B",
        "difficulty": 2
    },
    {
        "name": "Terra",
        "hex": "#964B00",
        "difficulty": 2
    },
    {
        "name": "Harvest",
        "hex": "#BB7431",
        "difficulty": 2
    },
    {
        "name": "Storm",
        "hex": "#4F666A",
        "difficulty": 2
    },
    {
        "name": "Rosemary",
        "hex": "#437C17",
        "difficulty": 2
    },
    {
        "name": "Lush",
        "hex": "#7CB342",
        "difficulty": 2
    },
    {
        "name": "Rainforest",
        "hex": "#005249",
        "difficulty": 2
    },
    {
        "name": "Mellow",
        "hex": "#F8BBD0",
        "difficulty": 2
    },
    {
        "name": "Majestic",
        "hex": "#8A2BE2",
        "difficulty": 2
    },
    {
        "name": "Opal",
        "hex": "#A8C3BC",
        "difficulty": 2
    },
    {
        "name": "Tranquil",
        "hex": "#F0FFFF",
        "difficulty": 2
    },
    {
        "name": "Opulent",
        "hex": "#FFD700",
        "difficulty": 2
    },
    {
        "name": "Willow",
        "hex": "#8F9779",
        "difficulty": 2
    },
    {
        "name": "Coastal",
        "hex": "#006994",
        "difficulty": 2
    },
    {
        "name": "Magnolia",
        "hex": "#F8F4FF",
        "difficulty": 2
    },
    {
        "name": "Jasper",
        "hex": "#D73B3E",
        "difficulty": 2
    },
    {
        "name": "Fig",
        "hex": "#4F2E4F",
        "difficulty": 2
    },
    {
        "name": "Limestone",
        "hex": "#F1E7D2",
        "difficulty": 2
    },
    {
        "name": "Quartz",
        "hex": "#E0D5C6",
        "difficulty": 2
    },
    {
        "name": "Terracotta",
        "hex": "#E2725B",
        "difficulty": 2
    },
    {
        "name": "Teak",
        "hex": "#B8860B",
        "difficulty": 2
    },
    {
        "name": "Zebrawood",
        "hex": "#E4D96F",
        "difficulty": 2
    },
    {
        "name": "Vermillion",
        "hex": "#FF4D00",
        "difficulty": 2
    },
    {
        "name": "Tusk",
        "hex": "#E4DED0",
        "difficulty": 2
    },
    {
        "name": "Periwinkle",
        "hex": "#CCCCFF",
        "difficulty": 2
    },
    {
        "name": "Seashell",
        "hex": "#FFF5EE",
        "difficulty": 2
    },
    {
        "name": "Mink",
        "hex": "#654321",
        "difficulty": 2
    },
    {
        "name": "Pebble",
        "hex": "#CFCFC4",
        "difficulty": 2
    },
    {
        "name": "Cornsilk",
        "hex": "#FFF8DC",
        "difficulty": 2
    },
    {
        "name": "Umber",
        "hex": "#635147",
        "difficulty": 2
    },
    {
        "name": "Azalea",
        "hex": "#F7C8DA",
        "difficulty": 2
    },
    {
        "name": "Claret",
        "hex": "#7F1734",
        "difficulty": 2
    },
    {
        "name": "Cornflower",
        "hex": "#6495ED",
        "difficulty": 2
    },
    {
        "name": "Flax",
        "hex": "#EEDC82",
        "difficulty": 2
    },
    {
        "name": "Praline",
        "hex": "#CC9966",
        "difficulty": 2
    },
    {
        "name": "Stratos",
        "hex": "#000741",
        "difficulty": 2
    },
    {
        "name": "Smalt",
        "hex": "#003399",
        "difficulty": 2
    },
    {
        "name": "Cyprus",
        "hex": "#003E40",
        "difficulty": 2
    },
    {
        "name": "Crusoe",
        "hex": "#004816",
        "difficulty": 2
    },
    {
        "name": "Camarone",
        "hex": "#00581A",
        "difficulty": 2
    },
    {
        "name": "Lochmara",
        "hex": "#007EC7",
        "difficulty": 2
    },
    {
        "name": "Azure Radiance",
        "hex": "#007FFF",
        "difficulty": 2
    },
]

export {
    NamedColors0,
    NamedColors1,
    NamedColors2
}